import React, { useContext, useState } from "react";
import FormInput from "../FormInputs/FormInput";
import "./signupForm.scss";
import { Formik } from "formik";
import FormPassInput from "../FormInputs/FormPassInput";
import PageButton from "components/PageButton/PageButton";
import axios from "axios";

// Context
import { CurrentUserContext } from "context/UserContext";
import { useHistory } from "react-router-dom";

//assets imports
import warning from "assets/icons/warning.png";

const validation = (values) => {
  let errors = {};

  if (!values.name) {
    errors.name = "El campo nombre es requerido";
  } else if (values.name.length < 2) {
    errors.name = "Inserte al menos dos letras";
  }
  if (!values.surname) {
    errors.surname = "El campo apellido es requerido";
  }
  if (!values.city) {
    errors.city = "El campo ciudad es requerido";
  } else if (values.city.length < 2) {
    errors.city = "Inserte al menos dos letras";
  }
  if (!values.email) {
    errors.email = "El campo email es requerido";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Dirección de email inválida";
  }
  if (!values.password) {
    errors.password = "El campo password es requerido";
  } else if (values.password.length < 6) {
    errors.password = "El password debe tener al menos 6 caracteres";
  }
  if (!values.password2) {
    errors.password2 = "El campo es requerido";
  } else if (values.password !== values.password2) {
    errors.password2 = "Las contraseñas deben coincidir";
  }
  return errors;
};

/**
 * Signup form done using Formik
 * @see <a href="https://www.paradigmadigital.com/dev/formik-desarrollando-formularios-react/">Formik - Desarrolando formularios React</a>
 */
const SignupForm = () => {
  const [, setUserContextData] = useContext(CurrentUserContext);
  const history = useHistory();
  const [errorState, setErrorState] = useState(false);

  const signup = async (name, surname, email, password, city) => {
    try {
      const signupResponse = await axios.post(
        `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/users/register`,
        {
          name,
          surname,
          email,
          password,
          city,
          roleName: "",
        }
      );
      if (signupResponse.status === 201) {
        const resultado = await axios.post(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/authenticate`,
          {
            email: email,
            password: password,
          }
        );

        setUserContextData({
          id: resultado.data.user.id,
          name: resultado.data.user.name,
          surname: resultado.data.user.surname,
          email: resultado.data.user.email,
          city: resultado.data.user.city,
          jwt: resultado.data.jwt,
          isLoggedIn: true,
        });

        history.push("/home");
      }
    } catch (error) {
      setErrorState(true);
      console.log(error.message);
    }
  };
  return (
    <Formik
      initialValues={{
        name: "",
        surname: "",
        city: "",
        email: "",
        password: "",
        password2: "",
      }}
      onSubmit={async (values, actions) => {
        await signup(
          values.name,
          values.surname,
          values.email,
          values.password,
          values.city
        );
        actions.setSubmitting(false);
      }}
      validate={validation}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {/**This props are injected by Formik*/}
      {(props) => <SignupFormTemplate {...props} errorState={errorState} />}
    </Formik>
  );
};

const SignupFormTemplate = ({ handleSubmit, isSubmitting, errorState }) => {
  return (
    <form className="signupForm" onSubmit={handleSubmit}>
      {errorState && (
        <div className="errorLoginReserve">
          <img src={warning} alt="warning" />
          <p>
            {" "}
            Lamentablemente no ha podido registrarse. Por favor, intente más
            tarde
          </p>
        </div>
      )}
      <div className="signup__horizontal__container">
        <FormInput name="name" type="text" label="Nombre" />
        <FormInput name="surname" type="text" label="Apellido" />
      </div>
      <div className="signup__vertical__container">
        <FormInput name="city" type="text" label="Ciudad" />
        <FormInput name="email" type="text" inputMode="email" label="Correo" />
        <FormPassInput name="password" type="password" label="Contraseña" />
        <FormInput
          name="password2"
          type="password"
          label="Confirmar contraseña"
        />
      </div>
      <div className="signup__single__container">
        <PageButton
          filled
          disabled={isSubmitting}
          type="submit"
          label="Crear cuenta"
          className="standardWidth"
        />
      </div>
    </form>
  );
};

export default SignupForm;
